<template>
  <v-flex xs12 sm12 md6 lg4 xl3>
    <v-card class="elevation-2">
      <v-img
        v-if="listing.media.length"
        :src="findFirstImage(listing.media).card_url"
        alt="House image"
        aspect-ratio="1.77"
        class="white--text"
      >
        <v-container fill-height fluid>
          <v-layout fill-height>
            <v-flex align-end flexbox pa-0>
              <v-chip
                v-if="listing.status === 'Sold'"
                color="red lighten-4"
                text-color="red darken-3"
                class="title right"
              >
                {{ listing.sale_price | currency('$', 0) }}
              </v-chip>
              <v-chip
                v-else
                color="light-blue lighten-4"
                text-color="light-blue darken-4"
                class="title right"
              >
                {{ listing.asking_price | currency('$', 0) }}
              </v-chip>
            </v-flex>
          </v-layout>
        </v-container>
      </v-img>
      <v-img v-else :src="image" aspect-ratio="1.77" class="white--text">
        <v-container fill-height fluid>
          <v-layout fill-height>
            <v-flex align-end flexbox pa-0>
              <span class="title right grey darken-1 pa-1">
                {{ listing.asking_price | currency('$', 0) }}
              </span>
            </v-flex>
          </v-layout>
        </v-container>
      </v-img>
      <v-card-title primary-title>
        <div>
          <h3 class="title mb-0">{{ listing.address_line_1 }}</h3>
          <p class="subheading grey--text">
            {{ listing.city }}, NV
            {{ listing.postalCode }}
          </p>
        </div>
      </v-card-title>
      <v-card-text class="pt-0">
        <v-layout align-center justify-center row text-xs-center>
          <v-flex subheading>{{ listing.num_bedrooms }} Beds</v-flex>
          <v-flex subheading> {{ listing.num_bathrooms }} Baths</v-flex>
          <v-flex subheading>
            {{ listing.lot_size | currency('', 0) }} Sq. Ft.
          </v-flex>
        </v-layout>
        <v-alert
          v-if="listing.status === 'New'"
          :value="true"
          color="info"
          icon="fas fa-info-circle"
          outline
        >
          To see the MLS listing, please enter the address (house number and and
          and street) in the search box above.
        </v-alert>
      </v-card-text>
      <v-card-actions>
        <app-social-share v-if="listing.status === 'New'"></app-social-share>
      </v-card-actions>
    </v-card>
  </v-flex>
</template>

<script>
export default {
  name: 'PrpgListingCard',
  props: {
    listing: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      image: require('../assets/desert.jpg'),
    };
  },
  methods: {
    findFirstImage(objArray) {
      return objArray.find((obj) => obj.order_column === 1);
    },
  },
};
</script>
